import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/common/font.css'
import 'vue2-animate/dist/vue2-animate.min.css'
import animated from 'animate.css' 
import axios from 'axios'
Vue.use(animated)

Vue.prototype.axios = axios;
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
